import { usePropertyId } from "../../../../common/hooks/usePropertyId";
import { withQueryData } from "../../../../common/withQueryData";
import RoomsList from "./RoomsList";
import { useRoomsData } from "../../../../common/hooks/useRoomsData";
import { useAlertNotification } from "../../../../common/hooks/useAlertNotification";

const RoomsPage = () => {
    const propertyId = usePropertyId();

    const { setAlert } = useAlertNotification();

    const { queryResults, deleteRoom } = useRoomsData(propertyId);

    const onCreateRoom = () => {
        setAlert({
            message: "Room successfully created!",
            severity: 'success'
        });
    }

    const onDeleteRoom = () => {
        setAlert({
            message: "Room successfully deleted",
            severity: 'success'
        });
    }

    const onUpdateRoom = () => {
        setAlert({
            message: "Room successfully updated!",
            severity: 'success'
        });
    }

    const onError = (error) => {
        setAlert({
            message: error.message || "An error occurred",
            severity: 'error'
        });
    }

    return <>
        <RoomsListWrapperWithQueryData
            queryData={queryResults}
            onCreateRoom={onCreateRoom}
            onDeleteRoom={onDeleteRoom}
            onUpdateRoom={onUpdateRoom}
            deleteRoom={(roomId) => deleteRoom(roomId)}
            propertyId={propertyId}
            onError={onError}
        />
    </>
}

const RoomsListWrapper = ({ data: rooms, reload, ...props }) => {
    return <>
        <RoomsList
            rooms={rooms}
            {...props}
        />
    </>
}

const RoomsListWrapperWithQueryData = withQueryData(RoomsListWrapper)

export default RoomsPage;